import { ScheduleEntry } from "../../Model/ImagingSchedule";
export enum EImagingScheduleAction {
  FETCH_IMAGING_SCHEDULE_PENDING = "FETCH_IMAGING_SCHEDULE_PENDING",
  FETCH_IMAGING_SCHEDULE_SUCCESS = "FETCH_IMAGING_SCHEDULE_SUCCESS",
  FETCH_IMAGING_SCHEDULE_ERROR = "FETCH_IMAGING_SCHEDULE_ERROR",
  SCHEDULED_PLATES_UPDATED = "SCHEDULED_PLATES_UPDATED",
  QUEUED_PLATES_UPDATED = "QUEUED_PLATES_UPDATED",
}

export interface ImagingScheduleAction {
  type: EImagingScheduleAction;
  queuedPlates?: ScheduleEntry[];
  scheduledPlates?: ScheduleEntry[];
  error?: Error;
}

export function fetchImagingSchedulePending() {
  return {
    type: EImagingScheduleAction.FETCH_IMAGING_SCHEDULE_PENDING,
  };
}

export function fetchImagingScheduleSuccess(queuedPlates: ScheduleEntry[], scheduledPlates: ScheduleEntry[]) {
  return {
    type: EImagingScheduleAction.FETCH_IMAGING_SCHEDULE_SUCCESS,
    queuedPlates: queuedPlates,
    scheduledPlates: scheduledPlates,
  };
}

export function queuedPlatesUpdated(queuedPlates: ScheduleEntry[]) {
  return {
    type: EImagingScheduleAction.QUEUED_PLATES_UPDATED,
    queuedPlates: queuedPlates,
  };
}

export function scheduledPlatesUpdated(scheduledPlates: ScheduleEntry[]) {
  return {
    type: EImagingScheduleAction.SCHEDULED_PLATES_UPDATED,
    scheduledPlates: scheduledPlates,
  };
}

export function fetchImagingScheduleError(error: Error) {
  return {
    type: EImagingScheduleAction.FETCH_IMAGING_SCHEDULE_ERROR,
    error: error,
  };
}
